<template>
      <div style="background:#FFF;padding:20px">
        <keep-alive v-if="multipage">
          <router-view ref="page"/>
        </keep-alive>
        <router-view ref="page" v-else>
          <router-view></router-view>
        </router-view>
      </div>
</template>

<script>
export default {
  name: 'PageView',
  data () {
    return {
      title: ''
    }
  },
  computed: {
    multipage () {
      return this.$store.state.setting.multipage
    }
  },
  mounted () {
    this.getPageHeaderInfo()
  },
  updated () {
    this.getPageHeaderInfo()
  },
  methods: {
    getPageHeaderInfo () {
      this.title = this.$route.name
    }
  }
}
</script>

<style lang="less" scoped>
  .extraImg{
    margin-top: -60px;
    text-align: center;
    width: 195px;
    img{
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/common/PageView.vue